import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "@/contexts/LanguageContext";
import { openWhatsApp, websitePhoneLabel, WEBSITE_PHONE_DEFAULT } from "@/lib/whatsapp";
import { api } from "@/lib/api";

const ZONE_MESSAGES = {
  alicante: {
    en: "Hello, I am interested in renting a car in Alicante. Could you help me check dates, availability, delivery and rental terms?",
    es: "Hola, me interesa alquilar un coche en Alicante. ¿Podéis ayudarme a consultar fechas, disponibilidad, entrega y condiciones?",
  },
  benidorm: {
    en: "Hello, I am interested in renting a car in Benidorm. Could you help me check dates, availability, delivery and rental terms?",
    es: "Hola, me interesa alquilar un coche en Benidorm. ¿Podéis ayudarme a consultar fechas, disponibilidad, entrega y condiciones?",
  },
};

const LOCAL_ZONE_MESSAGES = {
  fr: (city) => "Bonjour, je souhaite louer une voiture à " + city + ". Pouvez-vous vérifier les dates, la disponibilité, la livraison et les conditions ?",
  de: (city) => "Hallo, ich interessiere mich für einen Mietwagen in " + city + ". Können Sie Termine, Verfügbarkeit, Lieferung und Bedingungen prüfen?",
  nl: (city) => "Hallo, ik wil graag een auto huren in " + city + ". Kunt u data, beschikbaarheid, aflevering en voorwaarden controleren?",
  pl: (city) => "Dzień dobry, interesuje mnie wynajem auta w " + (city === "Alicante" ? "Alicante" : "Benidormie") + ". Czy możecie sprawdzić terminy, dostępność, dostawę i warunki?",
  ru: (city) => "Здравствуйте, меня интересует аренда автомобиля в " + (city === "Alicante" ? "Аликанте" : "Бенидорме") + ". Помогите уточнить даты, доступность, доставку и условия."
};
export default function StickyWhatsApp() {
  const { lang, t } = useLang();
  const location = useLocation();
  const [s, setS] = useState({});
  useEffect(() => { (async () => { try { const { data } = await api.get("/settings"); setS(data || {}); } catch { /* ignore */ } })(); }, []);
  if (location.pathname.startsWith("/admin")) return null;
  const zone = location.pathname.match(/luxury-car-rental-(alicante|benidorm)(?:\/|$)/)?.[1];
  const message = ZONE_MESSAGES[zone]?.[lang] || (zone && LOCAL_ZONE_MESSAGES[lang]?.(zone === "alicante" ? "Alicante" : "Benidorm")) || t.whatsapp.generic;


  return (
    <div className="md:hidden fixed bottom-0 inset-x-0 z-40 glass-dark border-t border-[#2A2A2A] p-3" data-testid="sticky-whatsapp">
      <button
        onClick={() => openWhatsApp(message, s, lang)}
        className="btn-red w-full"
        data-testid="sticky-whatsapp-btn">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
          <path d="M.057 24l1.687-6.163a11.867 11.867 0 0 1-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.82 11.82 0 0 1 8.413 3.488 11.82 11.82 0 0 1 3.48 8.414c-.003 6.557-5.34 11.892-11.893 11.892a11.9 11.9 0 0 1-5.688-1.448L.057 24z"/>
        </svg>
        WhatsApp · {websitePhoneLabel(s) || WEBSITE_PHONE_DEFAULT}
      </button>
    </div>
  );
}
